module.exports = __webpack_public_path__ + "img/trong.b2e39f9b.jpg";